function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import axios from 'axios';
export const LDS_URL = 'http://localhost:12345';
export const ldsAxios = axios.create({
    baseURL: LDS_URL
});
export class LDSHttpClient {
    constructor(){
        _define_property(this, "_api", void 0);
        _define_property(this, "get", (url, config)=>{
            return this._api.get(url, config).then((x)=>x.data);
        });
        _define_property(this, "post", (url, data, config)=>{
            return this._api.post(url, data, config).then((x)=>x.data);
        });
        this._api = ldsAxios;
    }
}
